import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { MY_WEIGHINGS_FILTERS, MyWeighingsScreen } from './-my-weighings-screen'

/**
 * "Số cân của tôi" — lối vào của tài khoản hộ trồng. Glue router ở đây, còn
 * toàn bộ màn nằm trong `-my-weighings-screen` để test render được không cần
 * dựng router.
 */
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/my-weighings',
)({
    component: MyWeighingsPage,
    validateSearch: MY_WEIGHINGS_FILTERS.validateSearch,
})

function MyWeighingsPage() {
    const navigate = useNavigate({ from: Route.fullPath })
    const search = Route.useSearch()

    return (
        <MyWeighingsScreen
            search={search}
            onSearchChange={(next, opts) =>
                void navigate({
                    search: () => next,
                    replace: opts?.replace ?? false,
                })
            }
        />
    )
}
